module.exports = __webpack_public_path__ + "img/f-soundcloud.949dfd96.svg";